// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__20CmI","notes":"Notes_notes__3qB-2","note":"Notes_note__1nt-O","markdown":"Notes_markdown__3l9mb"};